import { Errors, ResponseCode } from 'enums';

export interface ApiResponse<T, U> {
  code: ResponseCode | Errors;
  message: string;
  payload: T | U | null;
}

export class ApiResult<T, U> {
  private code: ResponseCode | Errors;
  private message: string;
  private payload: ApiResponse<T, U>['payload'];

  constructor({ code, message, payload }: ApiResponse<T, U>) {
    this.code = code || Errors.ERROR;
    this.message = message || '';
    this.payload = payload || null;
  }

  get data() {
    return this.payload as T;
  }

  get error() {
    return this.payload as U;
  }

  get success() {
    return this.code === ResponseCode.OK;
  }

  get fail() {
    return this.code !== ResponseCode.OK;
  }
}
